import React, { useContext, useEffect, useState, useRef } from 'react'
import { CButton, CCard, CCol, CFormInput, CFormLabel, CFormSelect, CRow } from '@coreui/react'

import useAxios from 'axios-hooks'

import { isEmpty } from 'lodash'
import { GlobalContext } from '../../../context/GlobalState'
import { AppContext } from '../../../context/app'
import moment from 'moment'
import FormListCard from '../formListCard'
import { getThumbnail } from '../../../utils/helper'
import AssetFilter from '../../AssetManager/AssetFilter'
import { LEAD_PARTNER_ANALYTICS } from '../../../utils/urls'
import { useHistory, useParams } from 'react-router-dom'
import getSymbolFromCurrency from 'currency-symbol-map'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import ArrowIcon from '../../../../assets/double-arrow-icon.svg'
import BackIcon from '../../../../assets/small-back-arrow.svg'
import DownloadIcon from '../../../../assets/small-download-icon.svg'

const LeadPartnerAnalytics = () => {
  let { partnerId } = useParams()
  const history = useHistory()
  const dateRangeRef = useRef(null)
  const [formData, setFormData] = useState([])
  const [leadDetail, setLeadDetail] = useState({})
  const [searchText, setSearchText] = useState('')
  const { userSessionObj } = useContext(GlobalContext)
  const { setLoader } = useContext(AppContext)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  const [{ data: formList, loading: formListLoading }, formListCall] = useAxios(
    {
      url: LEAD_PARTNER_ANALYTICS,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    formListCall({
      params: {
        partner_id: partnerId,
      },
    })
  }, [])

  useEffect(() => {
    setLoader(formListLoading)
  }, [formListLoading])

  useEffect(() => {
    if (formList && formList.success) {
      setFormData(formList.data.form_details)
      setLeadDetail(formList.data.lead_detail)
    }
  }, [formList])

  const handleApply = (event, picker) => {
    picker.element.val(
      picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'),
    )
    setStartDate(moment.utc(picker.startDate).format('YYYY-MM-DDTHH:mm:ss'))
    setEndDate(moment.utc(picker.endDate).format('YYYY-MM-DDTHH:mm:ss'))
    formListCall({
      params: {
        partner_id: partnerId,
        start_date: moment.utc(picker.startDate).format('YYYY-MM-DDTHH:mm:ss'),
        end_date: moment.utc(picker.endDate).format('YYYY-MM-DDTHH:mm:ss'),
      },
    })
  }

  const handleCancel = (event, picker) => {
    picker.element.val('')
    setStartDate('')
    setEndDate('')
    formListCall({
      params: {
        partner_id: partnerId,
      },
    })
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div className="w-100 ">
          <div className="d-flex align-items-center justify-content-between w-100 ">
            <div className="d-flex align-items-center">
              <h4 style={{ fontSize: '1.5625vw' }} className="font-bold mb-0">
                Lead Partner Analytics
              </h4>
              <img src={ArrowIcon} alt="ArrowIcon" className="mx-2" />
              <h4 style={{ fontSize: '1.5625vw' }} className="font-bold mb-0">
                {leadDetail?.name}
              </h4>
            </div>
            <CButton
              className="text-white px- py-1"
              onClick={() => {
                history.push('/custom-forms/lead-partners')
              }}
              style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
            >
              <img src={BackIcon} alt="BackIcon" className="mr-2" />
              Back
            </CButton>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between mb-2 mt-2">
        <div className="mx-3">
          <DateRangePicker
            ref={dateRangeRef}
            initialSettings={{
              autoUpdateInput: false,
              locale: { format: 'DD/MM/YYYY', cancelLabel: 'Clear' },
              placeholder: 'Select Date Range',
            }}
            onApply={handleApply}
            onCancel={handleCancel}
          >
            <CFormInput
              size="sm"
              type="text"
              className=""
              defaultValue=""
              placeholder="Select Date Range"
            />
          </DateRangePicker>
        </div>

        <CButton
          className="text-white px-3"
          onClick={() => console.log('yes')}
          style={{ pointerEvents: 'auto', fontSize: '12px', background: '#20211c' }}
        >
          <img src={DownloadIcon} alt="DownloadIcon" style={{ height: '10px' }} /> Download
        </CButton>
      </div>

      <CCard style={{}} className="">
        <div>
          <div id="" className="asset-manager-card position-relative">
            <div
              className="d-flex px-2 justify-content-center align-items-center w-100 bg-black text-white position-absolute"
              style={{
                fontSize: 'max(0.63vw,10px)',
                // gap: '0 2.2%',
                paddingTop: '2px',
                paddingBottom: '2px ',
                top: '0',
                zIndex: '10',
              }}
            >
              <div style={{ marginBlockEnd: '0', width: '10%' }} className="text-center mx-2" />
              <div style={{ width: '90%' }} className="d-flex align-items-center">
                <div style={{ marginBlockEnd: '0', width: '36%' }}>Form Name</div>
                <div style={{ marginBlockEnd: '0', width: '19%' }}>Created on</div>
                <div style={{ marginBlockEnd: '0', width: '12%' }}>Status</div>
                <div style={{ width: '14%' }}># Responses</div>
                <div style={{ width: '14%' }}>Total Revenue</div>
              </div>
            </div>
            <div style={{ height: '65vh' }} className="static-scrollbar-class">
              <div
                className="d-flex flex-wrap "
                style={{
                  gap: '1.2vw 0',
                  padding: '30px 8px 20px 8px',
                }}
              >
                {!isEmpty(formData) ? (
                  [...formData]
                    .filter((data) =>
                      searchText.trim().length
                        ? data.name.toLowerCase().includes(searchText.toLowerCase())
                        : true,
                    )
                    .map((info, index) => {
                      return (
                        <FormListCard
                          cardImage={getThumbnail(
                            userSessionObj.session_data.cf_domain_name,
                            info?.thumbnail?.s3_key,
                          )}
                          textData={[
                            {
                              name: info?.name,
                              styles: {
                                overflow: 'hidden',
                                fontSize: '14px',
                                width: '36%',
                              },
                            },
                            {
                              name: moment(info?.created_date).format('DD MMM YYYY'),
                              styles: { width: '19%' },
                            },
                            {
                              name: info?.status ? 'Active' : 'Disable',
                              styles: { width: '12%' },
                            },
                            {
                              name: info?.total,
                              styles: { width: '14%' },
                            },
                            {
                              name:
                                getSymbolFromCurrency(leadDetail?.lead_user_meta.currency) +
                                info?.revenue,
                              styles: { width: '14%' },
                            },
                          ]}
                          key={index}
                          disableStatus={true}
                          actionButtonOptions={[]}
                        />
                      )
                    })
                ) : (
                  <p> No Data Available for the selected filters</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </CCard>
    </>
  )
}

export default LeadPartnerAnalytics
